import React from 'react';
import { InsightsTimeframeSelection } from 'shared/components/ui/insights-timeframe-selection';
import { InsightsTimeframes } from 'shared/types/insights';

export type MetaStatisticsTimeframeProps = {
  timeframe: InsightsTimeframes;
  onChange: (timeframe: InsightsTimeframes) => void;
};

export const MetaStatisticsTimeframe: React.FC<
  MetaStatisticsTimeframeProps
> = ({ timeframe, onChange }) => (
  <InsightsTimeframeSelection
    value={timeframe}
    onChange={onChange}
    hasDarkBackground
  />
);
